<template>
  <v-text-field v-model="searchQuery" :loading="isSearching" :outlined="$vuetify.breakpoint.smAndDown"
                :placeholder="$vuetify.lang.t('$vuetify.general.searchInAllSites')" append-icon="mdi-magnify"
                clearable hide-details @click:append="$router.push({name:'search', query: {query: searchQuery}})"/>
</template>

<script>
import { SET_SEARCH_QUERY } from '@/modules/app/store/mutation-types'

export default {
  name: 'KurccSearchBox',
  computed: {
    searchQuery: {
      get () {
        return this.$store.state.search.query
      },
      set (v) {
        const query = v != null ? v : ''
        this.$store.commit(SET_SEARCH_QUERY, query)
      }
    },
    isSearching () {
      return this.$store.state.search.isSearching
    }
  }
}
</script>
